// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainObject {
    font-size: 24px;
}

.selectedObject {
    font-weight: bold;
}

.subObject {
    color: gray;
}

    .subObject.hasUsage {
        color: black;
        cursor: pointer;
    }

.section {
    margin-left: 40px;
}

.borderObject {
    padding: 2px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/service.workflow.usage.dialog.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;IAEI;QACI,YAAY;QACZ,eAAe;IACnB;;AAEJ;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".mainObject {\n    font-size: 24px;\n}\n\n.selectedObject {\n    font-weight: bold;\n}\n\n.subObject {\n    color: gray;\n}\n\n    .subObject.hasUsage {\n        color: black;\n        cursor: pointer;\n    }\n\n.section {\n    margin-left: 40px;\n}\n\n.borderObject {\n    padding: 2px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
